export default __webpack_public_path__ + "static/media/SetupMultipleCollateral.41b15fe7.svg";